import React, { useState, useEffect } from 'react';

interface TypewriterProps {
  text: string;
  speed?: number;
  onComplete?: () => void;
}

export const Typewriter: React.FC<TypewriterProps> = ({ text, speed = 15, onComplete }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else if (onComplete) {
      onComplete();
    }
  }, [currentIndex, text, speed, onComplete]);

  // If text changes drastically (e.g. reused component), reset
  useEffect(() => {
    if (text.length > 0 && currentIndex === 0 && displayedText !== '') {
       // This handles the case where we might want to reset, but simple mounting is safer.
       // For now, we assume the component is mounted fresh for new text or text doesn't change mid-stream.
    }
  }, [text]);

  return <span>{displayedText}</span>;
};
